// Modál „💾 Uložit skupinu“ (jen admin) — v editačním režimu nabízí přepsat / uložit jako novou (viz sekce VI plánu)
import { useState } from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { adminApi } from '../../api/adminApi'
import { ModalOverlay } from '../ModalOverlay'

export function SaveGroupModal({ definition, groupFilter, editingGroup, onClose }) {
  const qc = useQueryClient()
  const isEditing = !!editingGroup
  const [mode, setMode] = useState(isEditing ? 'overwrite' : 'new') // 'overwrite' | 'new'
  const [name, setName] = useState(isEditing ? editingGroup.name : '')
  const [description, setDescription] = useState(isEditing ? editingGroup.description ?? '' : '')
  const [error, setError] = useState(null)

  const mutation = useMutation({
    mutationFn: () => {
      if (isEditing && mode === 'overwrite') {
        return adminApi.updateSavedStationGroup(editingGroup.id, { name, definition, group_filter: groupFilter })
      }
      return adminApi.createSavedStationGroup({ name, description, definition, group_filter: groupFilter })
    },
    onSuccess: (result) => {
      qc.invalidateQueries({ queryKey: ['saved-station-groups'] })
      onClose(result)
    },
    onError: (err) => setError(err.message),
  })

  function handleSubmit(e) {
    e.preventDefault()
    setError(null)
    if (!name.trim()) {
      setError('Zadejte název skupiny.')
      return
    }
    mutation.mutate()
  }

  return (
    <ModalOverlay onClose={() => onClose(null)} className="z-50">
      <div className="bg-white rounded-2xl shadow-xl p-6 w-full max-w-sm flex flex-col gap-4">
        <h2 className="text-lg font-bold text-gray-800">Uložit skupinu</h2>

        <form onSubmit={handleSubmit} className="flex flex-col gap-3">
          {isEditing && (
            <div className="flex flex-col gap-1.5 text-sm">
              <label className="flex items-center gap-2 cursor-pointer">
                <input type="radio" name="mode" checked={mode === 'overwrite'} onChange={() => setMode('overwrite')} className="accent-blue-500" />
                <span>Přepsat existující skupinu</span>
              </label>
              {mode === 'overwrite' && (
                <input
                  type="text"
                  value={name}
                  onChange={e => setName(e.target.value)}
                  className="ml-6 border border-gray-300 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                  autoFocus
                />
              )}
              <label className="flex items-center gap-2 cursor-pointer">
                <input type="radio" name="mode" checked={mode === 'new'} onChange={() => setMode('new')} className="accent-blue-500" />
                Uložit jako novou skupinu
              </label>
            </div>
          )}

          {mode === 'new' && (
            <>
              <div className="flex flex-col gap-1">
                <label className="text-xs text-gray-500 font-medium">Název *</label>
                <input
                  type="text"
                  value={name}
                  onChange={e => setName(e.target.value)}
                  className="border border-gray-300 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                  autoFocus
                />
              </div>
              <div className="flex flex-col gap-1">
                <label className="text-xs text-gray-500 font-medium">Popis</label>
                <textarea
                  value={description}
                  onChange={e => setDescription(e.target.value)}
                  className="border border-gray-300 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                  rows={2}
                />
              </div>
            </>
          )}

          {error && (
            <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">{error}</p>
          )}

          <div className="flex gap-3 justify-end pt-1">
            <button type="button" onClick={() => onClose(null)}
              className="px-4 py-2 text-sm rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition-colors">
              Zrušit
            </button>
            <button type="submit" disabled={mutation.isPending}
              className="px-4 py-2 text-sm rounded-lg bg-blue-600 text-white font-semibold hover:bg-blue-700 disabled:opacity-50 transition-colors">
              Uložit
            </button>
          </div>
        </form>
      </div>
    </ModalOverlay>
  )
}
